import { publish } from '~/event-bus';
import { on, throttle } from '~/helpers';
import { CartItems } from '~/cart-items';
import { SectionFragment } from '~/section-fragment';
import { SelectProvider } from '~/select-provider';
import { ToggleButton, ToggleElement } from '~/toggle-element';
import { LineItem } from '~/line-item';
import { ResponsiveVideo } from '~/responsive-video';
import { SwiperPagination } from '~/swiper-pagination';
import { IntersectionState } from '~/intersection-state';
import { SliderElement } from '~/slider-element';
import { InputDropdown } from '~/input-dropdown';
import { QuantitySelector } from '~/quantity-selector';
import { ContentTabs } from '~/content-tabs';
import { QuickAddButton } from '~/quick-add-button';
import { TooltipContainer } from '~/tooltip-container';
import { ParallaxScroll } from '~/parallax-scroll';

/**
 * Keyboard events.
 */
on('keyup', document, (event) => {
  if (event.key === 'Escape') publish('key:escape');
});

/**
 * Scroll events.
 */
on(
  'scroll',
  window,
  throttle(() => {
    if (window.scrollY === 0) {
      document.body.classList.add('is-at-top');
      return;
    }

    document.body.classList.remove('is-at-top');
  }),
  null,
  true
);

/**
 * Custom elements.
 */
customElements.define('select-provider', SelectProvider);
customElements.define('section-fragment', SectionFragment);
customElements.define('cart-items', CartItems);
customElements.define('toggle-element', ToggleElement);
customElements.define('line-item', LineItem);
customElements.define('responsive-video', ResponsiveVideo);
customElements.define('swiper-pagination', SwiperPagination);
customElements.define('intersection-state', IntersectionState);
customElements.define('slider-element', SliderElement);
customElements.define('input-dropdown', InputDropdown);
customElements.define('quantity-selector', QuantitySelector);
customElements.define('content-tabs', ContentTabs);
customElements.define('quick-add-button', QuickAddButton);
customElements.define('tooltip-container', TooltipContainer);
customElements.define('toggle-button', ToggleButton);
customElements.define('parallax-scroll', ParallaxScroll);
